import { useEffect, useRef, useState, useCallback, useMemo } from 'react';
import {

	Sparkles,

} from "lucide-react";



import { useNotes } from "../contexts/NotesContext";
import { useCommunication } from '@/lib/CommunicationWrapper';
import { CLOUDFLARE_URL } from '@/lib/config';
import { ContentBottomGradient } from './ContentBottomGradient';
import { formatInlineMarkdown } from '../lib/util';
//import { showError } from '@/lib/globals';
const showError = () => {};
//import { RestrictedButton, RestrictedButtonView, RestrictedIcon, RestrictedView, UnrestrictedButtonView } from '@/components/RestrictedButton';
import { RestrictedButton, RestrictedButtonView, RestrictedIcon, RestrictedView, UnrestrictedButtonView } from '@/lib/restrictions';

const GenerateSmartNoteBtn = () => {


	const { noteId, setSmartNote, getSmartNoteContent, settings, transcript } = useNotes();
	const { authenticatedClient, authenticatedFetch } = useCommunication();

	const generate = async () => {

		const client = await authenticatedClient();

		if (!client) {
			//showError("There was an error while generating smart note", "error");
		};

		const res = await authenticatedFetch(`${CLOUDFLARE_URL}/notes/smart-note`, {
			method: 'POST',
			body: {
				noteId: noteId
			}
		} as any);

		if (!res.body) return;

		const reader = res.body.getReader();
		const decoder = new TextDecoder();
		let accumulatedResponse = '';

		while (true) {
			const { done, value } = await reader.read();
			if (done) break;

			// Decode the chunk and split by double newlines (SSE format)
			const chunk = decoder.decode(value);
			const lines = chunk.split('\n\n');

			for (const line of lines) {
				console.log("line", line);
				if (line.startsWith('data: ')) {
					try {
						const eventData = JSON.parse(line.slice(6));

						if (eventData.type === 'delta') {
							accumulatedResponse += eventData.delta || '';
							setSmartNote(accumulatedResponse);
							// Update the last message with the accumulated response
						} else if (eventData.type === 'done') {
							setSmartNote(eventData.text || accumulatedResponse);
						} else if (eventData.type === 'error') {
							console.error('Stream error:', eventData.error);
							throw new Error(eventData.error);
						}
					} catch (e) {
						console.error('Error parsing stream data:', e);
					}
				}
			}
		}
	}

	return (
		<div className="flex flex-col items-center justify-center">
			<RestrictedButton restrictedPlans={["none", "free", "proLite"]} onClick={generate}>
				<RestrictedButtonView>
					<button onClick={generate}>
						<RestrictedIcon restrictedPlans={["none", "free", "proLite"]} className="size-3.5 fill-current text-theme-0">
							<span>Generate smart note</span>
						</RestrictedIcon>
					</button>
				</RestrictedButtonView>
				<UnrestrictedButtonView>
					<button onClick={generate}>
						<RestrictedIcon restrictedPlans={["trial", "trialThenPro"]} className="size-3.5 fill-current text-theme-0" side="bottom">
							<Sparkles className="w-[20px] h-[20px]" />
							<span>Generate smart note</span>
						</RestrictedIcon>
					</button>
				</UnrestrictedButtonView>
			</RestrictedButton>
			<p className="text-sm text-theme-1 text-center mt-[5px]">Based on your notes {transcript.length > 0 ? " and transcript" : ""}</p>
		</div>
	)
}

export const SmartNoteContent = () => {

	const { noteId, smartNote, getSmartNoteContent, setSmartNote, transcript } = useNotes();
	const [loading, setLoading] = useState(false);
	const init = useRef(false);

	useEffect(() => {
		if (!noteId) return;
		if (init.current === true) return;
		init.current = true;
		setLoading(true);
		getSmartNoteContent(noteId).then((smartNote: any) => {
			setSmartNote(smartNote);
			setLoading(false);
		});
	}, [noteId]);

	if (loading) {
		return (
			<div className="flex flex-col gap-[10px]">
			</div>
		)
	}

	if (!smartNote) {
		return (
			<div className="flex items-center justify-center h-full w-full">
				<GenerateSmartNoteBtn />
			</div>
		)
	};

	return (
		<div className="flex flex-col gap-[10px]">
			<div className="pb-[40px]" dangerouslySetInnerHTML={{ __html: formatInlineMarkdown(smartNote) }} />

		</div>
	)
}

export const SmartNotesTab = () => {

	const { activeTab } = useNotes();

	if (activeTab !== "ai") return null;

	return (
		<div className="w-full h-full relative min-h-0 overflow-auto">
			<SmartNoteContent />
			<ContentBottomGradient />
		</div>
	);
}